import React from 'react';
import AuthorBox from 'gatsby-core-theme/src/components/atoms/author-box';

export default function index(props) {
  const newProps = {
    ...props,
    style: 'template_three',
  };
  return <AuthorBox {...newProps} />;
}
